export default __webpack_public_path__ + "static/media/team1.dc9612af.jpg";